/**
 * Por onde a pessoa entrou da última vez.
 *
 * É a ideia que a Voa aplica na tela dela: das duas portas oferecidas, uma
 * ganha uma etiqueta discreta dizendo que foi a usada por último. Parece
 * enfeite e não é - **quem tem conta com Google e tenta a senha não recebe uma
 * negativa útil**, porque o servidor responde "e-mail ou senha incorretos" para
 * qualquer falha, de propósito, para não revelar quem tem conta. A etiqueta
 * resolve antes de acontecer: a pessoa reconhece o caminho e nem tenta o outro.
 *
 * Mora no navegador, e só nele. É preferência de conveniência, não identidade:
 * não vale a pena uma coluna no banco, uma rota e um join na sessão para
 * lembrar de qual dos dois botões alguém apertou. Em navegador anônimo ou
 * aparelho novo simplesmente não há etiqueta, que é o comportamento certo.
 */
export type FormaDeEntrada = 'google' | 'email';

const CHAVE = 'titularis:forma-de-entrada';

/**
 * Grava a forma usada.
 *
 * O Google é gravado **na intenção**, e não na volta: o fluxo dele sai do nosso
 * domínio e devolve a pessoa já autenticada na página de destino, onde esta
 * tela não existe mais para anotar nada. Quem desiste no consentimento do
 * Google fica com a etiqueta no botão do Google - que é, afinal, para onde
 * estava indo -, e a primeira entrada por senha corrige sozinha.
 */
export function lembrarFormaDeEntrada(forma: FormaDeEntrada): void {
  try {
    window.localStorage.setItem(CHAVE, forma);
  } catch {
    // Navegação anônima e armazenamento bloqueado lançam aqui. Não lembrar é
    // um resultado aceitável; quebrar o login por causa disso, não.
  }
}

/** A forma da última vez, se o navegador ainda souber. */
export function formaDeEntradaAnterior(): FormaDeEntrada | null {
  try {
    const valor = window.localStorage.getItem(CHAVE);
    return valor === 'google' || valor === 'email' ? valor : null;
  } catch {
    return null;
  }
}
